export const en = {
  'modal-container': {
    unsavedConfirmation: {
      title: 'Discard Unsaved Information',
      text: 'You have entered new information in this window. If you close it now without saving, the information will be lost.',
      discard: 'Discard',
      cancel: 'Cancel'
    }
  }
};
